import { Action, Dispatch } from 'redux'
import { showLoadingAction } from 'reducks/loading/actions'

const showLoading = () => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch(showLoadingAction())
  }
}

export default showLoading
